export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_STORAGE_KEY = 'i18nextLng';
export const LEGACY_LANGUAGE_STORAGE_KEYS = ['app_language', 'language'];

export const LANGUAGES = [
  { id: 'en', label: 'English', direction: 'ltr' },
  { id: 'pl', label: 'Polski', direction: 'ltr' },
  { id: 'ro', label: 'Română', direction: 'ltr' },
  { id: 'fr', label: 'Français', direction: 'ltr' },
  { id: 'es', label: 'Español', direction: 'ltr' },
  { id: 'ar', label: 'العربية', direction: 'rtl' },
  { id: 'ur', label: 'اردو', direction: 'rtl' },
  { id: 'bn', label: 'বাংলা', direction: 'ltr' },
  { id: 'pa', label: 'ਪੰਜਾਬੀ', direction: 'ltr' },
  { id: 'so', label: 'Soomaali', direction: 'ltr' },
  { id: 'pt', label: 'Português', direction: 'ltr' },
  { id: 'it', label: 'Italiano', direction: 'ltr' },
  { id: 'gu', label: 'ગુજરાતી', direction: 'ltr' },
  { id: 'tr', label: 'Türkçe', direction: 'ltr' },
  { id: 'fa', label: 'فارسی', direction: 'rtl' },
  { id: 'zh', label: '中文', direction: 'ltr' },
  { id: 'tl', label: 'Filipino', direction: 'ltr' },
];

export const SUPPORTED_LANGUAGE_IDS = LANGUAGES.map(({ id }) => id);

export function normalizeEnabledLanguageIds(value) {
  if (!Array.isArray(value) || value.length === 0) return null;
  const configured = [...new Set(value.map(normalizeLanguageId).filter((id) => SUPPORTED_LANGUAGE_IDS.includes(id)))];
  return configured.includes('en') ? configured : ['en', ...configured];
}

export function getEnabledLanguageIds(value) {
  return normalizeEnabledLanguageIds(value) || SUPPORTED_LANGUAGE_IDS;
}
const LANGUAGE_BY_ID = new Map(LANGUAGES.map((language) => [language.id, language]));

export function normalizeLanguageId(value) {
  if (!value) return null;
  return String(value).trim().toLowerCase().split('-')[0] || null;
}

export function isSupportedLanguage(value) {
  const languageId = normalizeLanguageId(value);
  return Boolean(languageId && LANGUAGE_BY_ID.has(languageId));
}

export function getLanguageDefinition(value) {
  const languageId = normalizeLanguageId(value);
  return LANGUAGE_BY_ID.get(languageId) || LANGUAGE_BY_ID.get(DEFAULT_LANGUAGE);
}

export function getStoredLanguage() {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;

  const candidates = [
    window.localStorage.getItem(LANGUAGE_STORAGE_KEY),
    ...LEGACY_LANGUAGE_STORAGE_KEYS.map((key) => window.localStorage.getItem(key)),
  ];

  return candidates.find(isSupportedLanguage) || DEFAULT_LANGUAGE;
}
